import { render, staticRenderFns } from "./ChatbotDashboard.vue?vue&type=template&id=577b7873&scoped=true"
import script from "./ChatbotDashboard.vue?vue&type=script&lang=js"
export * from "./ChatbotDashboard.vue?vue&type=script&lang=js"
import style0 from "./ChatbotDashboard.vue?vue&type=style&index=0&id=577b7873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577b7873",
  null
  
)

export default component.exports